import { useState } from "react";
import { useQuery } from "@apollo/client";
import { ActionIcon, Drawer, Group, Header, Text, Flex, Center } from "@mantine/core";
import { Link } from "react-router-dom";
import { UserCircle } from "tabler-icons-react";
import { ME_QUERY } from "../../../queries/waves";
import "./NCEHeader.css"; // Import the CSS file

export default function NCEHeader({ user, logout }) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  // isAdmin isn't on the User type (CURRENT_USER) — reuse the same `me` check
  // RequireAdmin uses, so the "Admin Panel" link only shows for real admins.
  const { data: meData } = useQuery(ME_QUERY, { skip: !user });
  const isAdmin = !!meData?.me?.isAdmin;

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      <Header className="header" height={70} p="md">
        <Group position="apart">
          <Text></Text>
          <Group>
            {user ? (
              <ActionIcon onClick={openDrawer} className="header__icon">
                <UserCircle size={36}/>
              </ActionIcon>
            ) : (
              <Text className="header__text">
                <Link to="/login" style={{ color: "white" }}>
                  Log In
                </Link>
              </Text>
            )}
          </Group>
        </Group>
      </Header>

      {user && (
        <Drawer
          opened={isDrawerOpen}
          onClose={closeDrawer}
          position="right"
          className="drawer"
          wrapperProps={{ style: { width: "100%" } }}
          // Match the close button's inset to the avatar button's inset in the
          // header above (Header uses p="md" = 16px) so the X lines up with it.
          styles={{ header: { padding: "16px 16px 0 16px" } }}
        >
          <Flex
            className="drawer__body"
            direction="column"
            justify="center"
            align="stretch"
            // Padding set inline (not just via CSS class) so it's guaranteed to
            // apply regardless of cascade order, and boxSizing: border-box so
            // the padding is included in the 100% width instead of adding to it
            // and pushing content past the drawer's right edge.
            style={{ width: "100%", height: "100%", boxSizing: "border-box", padding: "0 20px 20px 20px" }}
          >
            <Center><h3 className="drawer__title"><span style={{ color: "orange" }}>Welcome, </span>{user.name}</h3></Center>
            <Link to="/profile" style={{ textDecoration: "none" }} onClick={closeDrawer}>
              <Text className="drawer__item">Profile</Text>
            </Link>
            <Link to="/settings" style={{ textDecoration: "none" }} onClick={closeDrawer}>
              <Text className="drawer__item">Settings</Text>
            </Link>
            {isAdmin && (
              <Link to="/admin" style={{ textDecoration: "none" }} onClick={closeDrawer}>
                <Text className="drawer__item">Admin Panel</Text>
              </Link>
            )}
            <Text onClick={() => { logout(); closeDrawer(); }} className="drawer__logout">
              Logout
            </Text>
          </Flex>
        </Drawer>
      )}
    </>
  );
}